
import React, {Component} from 'react'
import { connect } from 'react-redux'
import {Button} from 'reactstrap';
import HeaderComponent from "../../components/header/HeaderComponent";
import { LuRefreshCw } from "react-icons/lu";
import ErrorComponent from '../../components/error/ErrorComponent.js'
import LoadingComponent from '../../components/loading/LoadingComponent'

import KitchenOverview from './KitchenOverview'
import SlotsOverview from './SlotsOverview'
import FloorOverview from './FloorOverview'
import SummaryOverview from './SummaryOverview'

const salesLoader = require('../../utils/domain/sales/salesLoader');
const logger = require('../../utils/logger/logger');
const translator = require('../../utils/translator/translator');
var stateManager = require('../../utils/state/stateManager.js');
var navigationPageAction = require('../../utils/state/actions/views/navigationPage/navigationPageAction');

class Overview extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.forceReloading = false;
        this.state.isLoadingSales = false;
        this.state.unmounted = false;

        this.state.tabs = [];
        this.state.tabs.push("kitchen_overview");
        this.state.tabs.push("time_slots_overview");
        this.state.tabs.push("tables_overview");
        this.state.selectedTab = this.state.tabs[0];
        this.state.cachedData = {};
    }

    componentDidMount() 
    {
        this.timerID = setInterval
        (
          () => 
          {
                this.setState({});
          },
          60000
        );
    }
    
    componentWillUnmount() 
    {
        clearInterval(this.timerID);
    }

    render()
    {
        if (this.state.forceReloading)
        {
            this.state.forceReloading = false;
            this.state.isLoadingSales = true;
            this.loadSales();
        }

        return <div className='h-100'>
                    <div>
                           {this.renderToolbar()}
                    </div>
                    <div style={{padding:'10px', height:'89%', overflowY:'auto'}}>
                        {this.renderBody()}
                    </div>
                </div>
    }

    renderToolbar()
    {
        var tabComponents = [];

        this.state.tabs.forEach(tab =>
        {
            tabComponents.push(<span
                                    style={{
                                    flexGrow: 1,
                                    display: "block",
                                    paddingTop: "0.8rem",
                                    textDecoration: "none",
                                    textAlign: 'center',
                                    color: this.state.selectedTab === tab ? "white" : "var(--colors-primary)",
                                    background: this.state.selectedTab === tab ? "var(--colors-primary)" : "white",
                                    borderRight: '1px solid var(--colors-primary)',
                                    cursor:'pointer',
                                    height:'var(--button-height)'
                                    }}
                                    onClick={()=>
                                    {
                                        logger.usage(`Overview.${translator.getLabel(tab)}`, "Staff clicked refresh button to switch to tab");
                                        this.state.selectedTab = tab;
                                        this.setState({});
                                    }}
                                >
                                    {translator.getLabel(tab)}
                                </span>)
        })
        return <HeaderComponent title={translator.getLabel("sales_overview")}>
                    
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{width:'99%'}}>
                                <nav style={{
                                            position: "relative",
                                            border: "1px solid #05149e"
                                            }}>

                                    <div
                                        style={{
                                            display: "flex"
                                        }}
                                    >
                                        {tabComponents}
                                    </div>
                                </nav>
                            </td>
                            <td>
                            <div style={{marginLeft:'20px', marginRight:'70px'}}>
                                <Button className='btn-action'disabled={this.state.isLoadingSales || this.state.error != null} style={{minWidth:'5vw'}}
                                        onClick={()=>
                                        {
                                            logger.usage("Overview.Refresh", "Staff clicked refresh button to refresh sales");
                                            this.state.forceReloading = true;
                                            this.setState({});
                                        }}>
                                    <LuRefreshCw/></Button>
                                    
                            </div>
                            </td>
                            <td>
                                <div style={{marginLeft:'5px'}}>
                                <Button className='btn-cancel'
                                    onClick={()=>
                                        {
                                            logger.usage("Overview.Exit", "Staff clicked exit button to exit");
                                            this.state.unmounted = true;
                                            stateManager.getStore().dispatch(navigationPageAction.createAction(null));
                                        }}>{translator.getLabel("exit")}</Button>
                                </div>
                            </td>
                            
                        </tr>
                    </table>
                    
                </HeaderComponent>
    }

    renderBody()
    {
        if (this.state.isLoadingSales)
        {
            return <div className='h-100 d-flex flex-column justify-content-center'>
                        <LoadingComponent waitMessage={translator.getLabel("please_wait_loading_sales")}/>
                   </div>
        }

        if (this.state.error != null)
        {
            return <div className='h-100 d-flex flex-column justify-content-center'>
                        <ErrorComponent error={this.state.error}/>
                    </div>
        }
        
        if (this.state.selectedTab == "kitchen_overview")
            return <KitchenOverview/>

        if (this.state.selectedTab == "time_slots_overview")
            return <SlotsOverview/>

        if (this.state.selectedTab == "tables_overview")
            return <FloorOverview/>

        if (this.state.selectedTab == "summary_overview")
            return <SummaryOverview/>
    }

    async loadSales()
    {
        try
        {
            await salesLoader.loadTodaysSalesAndSalesStatus();
            if (this.state.unmounted) return;
            
            this.state.isLoadingSales = false;
            this.setState({});
        }
        catch(error)
        {
            logger.error(`Error occurred while loading sales in sales view. ${error}`, {}, error);
            if (this.state.unmounted) return;

            this.state.isLoadingSales = false;
            this.state.error = error;
            this.setState({});
        }
    }
}

const mapStateToProps = state => 
{
    return { 
                todaysSalesUpdatedDateTime: state.todaysSalesUpdatedDateTime,
          }
}

export default connect(mapStateToProps)(Overview)